"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestType = exports.ResourceType = void 0;
exports.ResourceType = {
    DOCUMENT: 'document',
    XHR: 'xhr',
    BEACON: 'beacon',
    FETCH: 'fetch',
    CSS: 'css',
    JS: 'js',
    IMAGE: 'image',
    FONT: 'font',
    MEDIA: 'media',
    OTHER: 'other',
};
exports.RequestType = {
    FETCH: exports.ResourceType.FETCH,
    XHR: exports.ResourceType.XHR,
};
//# sourceMappingURL=resourceUtils.js.map